import { UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, MenuProps } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { ProfileMenuItem } from './profile-menu-item'
import { UserModal } from './user-modal'
import { ApiResponseStatus } from '../../../../../common/api/constants/api-response.status'
import { useModal } from '../../../../../common/hooks/formik/modal.hook'
import { ModalRight } from '../../../../../common/ui/modal/modal-right'
import { RouteEnum } from '../../../../../constants/routes.enum'
import { useLogout } from '../../../../../entities/auth/hooks/auth.hooks'
import { useUserStore } from '../../../../../entities/user/stores/user.store'

type UserDropdownProps = {
  hasMenu: boolean
}

export const UserDropdown = ({ hasMenu = false }: UserDropdownProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { user: storeProfileData, updateUser: setStoreProfileData } = useUserStore()
  const { mutateAsync: logoutOnServer } = useLogout()
  const [profileData, setLocalProfileData] = useState(storeProfileData)

  if (storeProfileData && !storeProfileData.isQuizPassed && !storeProfileData.isStaff && !location.pathname.includes(RouteEnum.ONBOARDING)) {
    navigate(`/${RouteEnum.ONBOARDING}`)
  }

  // TODO FIX THIS
  const handleProfileChange = (updatedProfileData: any) => {
    setLocalProfileData(updatedProfileData)
  }

  const handleProfileSave = () => {
    try {
      if (profileData) {
        setStoreProfileData(profileData)
      }
      userModal.close()

      toast.success('Profile updated successfully.')
    } catch {
      toast.error('Profile updated successfully.')
    }
  }

  const userModal = useModal(false)

  const logout = async () => {
    const logoutResult = await logoutOnServer()
    if (logoutResult.status === ApiResponseStatus.Success) {
      toast.success(t('auth.logout.success'))
      navigate(`/${RouteEnum.AUTH}`)
    } else {
      toast.error(t('auth.logout.error'))
    }
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'profile-header',
      label: <ProfileMenuItem user={profileData} />,
      onClick: () => userModal.open(),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: t('auth.logout.label'),
      icon: <LogoutOutlined />,
      onClick: () => logout(),
    },
  ]

  if (hasMenu) {
    menuItems.splice(2, 0, {
      key: 'organization settings',
      label: t('settings.label'),
      icon: <SettingOutlined />,
      onClick: () => navigate(RouteEnum.SETTINGS),
    })
    menuItems.splice(3, 0, {
      type: 'divider',
    })
  }

  return (
    <div>
      <Dropdown
        className="cursor-pointer"
        menu={{ items: menuItems }}
        trigger={['hover', 'click']}
      >
        <Avatar
          icon={!storeProfileData?.avatar && <UserOutlined />}
          size={42}
          src={storeProfileData?.avatar}
        />
      </Dropdown>

      <ModalRight
        cancelText={t('common.cancel')}
        okText={t('common.save')}
        onCancel={userModal.close}
        onOk={handleProfileSave}
        open={userModal.opened}
        title={t('settings.profile')}
      >
        <UserModal
          onChange={handleProfileChange}
          profileData={profileData}
        />
      </ModalRight>
    </div>
  )
}
